module.exports = __webpack_public_path__ + "img/turbo1.d46aac1e.jpg";